import { render, staticRenderFns } from "./EventConfigurationTabComponent.vue?vue&type=template&id=70a0ea58&scoped=true"
import script from "./EventConfigurationTabComponent.js?vue&type=script&lang=js&external"
export * from "./EventConfigurationTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./EventConfigurationTabComponent.vue?vue&type=style&index=0&id=70a0ea58&prod&scoped=true&lang=scss"
import style1 from "./EventConfigurationTabComponent.vue?vue&type=style&index=1&id=70a0ea58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0ea58",
  null
  
)

export default component.exports